import type { CodeableConcept } from '@medplum/fhirtypes'
import { codeableConcept } from '#src/codeableConcept.ts'
import { COMPOSITION_CATEGORY, COMPOSITION_TYPE } from '#src/codeSystems.ts'

export const CompositionCategory = {
  Assessment: codeableConcept({
    system: COMPOSITION_CATEGORY,
    code: 'assessment',
    display: 'Assessment',
  }),
  CarePlanSnapshot: codeableConcept({
    system: COMPOSITION_CATEGORY,
    code: 'care-plan-snapshot',
    display: 'Care Plan Snapshot',
  }),
  Note: codeableConcept({
    system: COMPOSITION_CATEGORY,
    code: 'note',
    display: 'Note',
  }),
  Incident: codeableConcept({
    system: COMPOSITION_CATEGORY,
    code: 'incident',
    display: 'Incident',
  }),
  PractitionerNotepad: codeableConcept({
    system: COMPOSITION_CATEGORY,
    code: 'practitioner-notepad',
    display: 'Practitioner Notepad',
  }),
} satisfies Record<string, CodeableConcept>

export const CompositionType = {
  PractitionerNotepad: codeableConcept({
    system: COMPOSITION_TYPE,
    code: 'practitioner-notepad',
    display: 'Practitioner Notepad',
  }),
} satisfies Record<string, CodeableConcept>
